module.exports = __webpack_public_path__ + "img/emoji_50.4f188cf5.png";